module.exports = __webpack_public_path__ + "media/images/1200/circadian_rhytm_mimosa_pudica-b5cb4c21696ae6d2291b128ad281c542.jpg";